import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../UI/PrimaryButton";
import { enqueueSnackbar } from "notistack";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import { API_BASE_URL } from "../../constants";

const ResetForm = ({ toggleForm }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const handleReset = async (event) => {
    event.preventDefault();

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        const errorMsg =
          data?.errors?.email?.[0] || data?.message || t("somethingWentWrong");
        enqueueSnackbar(errorMsg, { variant: "error" });
        return;
      }

      enqueueSnackbar(data.status || data.message, { variant: "success" });
      setTimeout(() => {
        toggleForm("login");
      }, 100);
    } catch {
      enqueueSnackbar(t("somethingWentWrong"), { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 z-50"
      onClick={() => toggleForm(null)}
    >
      <div
        className="bg-white p-8 rounded-lg shadow-2xl max-w-md w-full relative m-2"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => toggleForm(null)}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 focus:outline-none"
          aria-label="Close reset form"
        >
          ✕
        </button>
        <h1 className="text-gray-800 text-2xl font-bold text-center mb-6">
          {t("resetPassword")}
        </h1>
        <form onSubmit={handleReset} className="space-y-6">
          <div>
            <label
              htmlFor="reset-email"
              className="block text-sm font-medium text-gray-600 mb-2"
            >
              {t("email")}
            </label>
            <input
              type="email"
              id="reset-email"
              placeholder={t("enterYourEmail")}
              className="w-full p-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <PrimaryButton
            text={loading ? <LoadingSpinner /> : t("reset")}
            type="submit"
            className={
              loading
                ? "opacity-75 cursor-not-allowed flex justify-center items-center"
                : ""
            }
            disabled={loading}
          />
        </form>
        <p className="text-gray-500 text-center mt-4">
          {t("rememberPassword")}{" "}
          <span
            onClick={() => toggleForm("login")}
            className="text-baseBlue underline cursor-pointer"
          >
            {t("login")}
          </span>
        </p>
      </div>
    </div>
  );
};

export default ResetForm;
